module.exports = __webpack_public_path__ + "img/EH.40888fcb.png";